module.exports = __webpack_public_path__ + "static/media/newsletter-june-2018-miter.94f61cfc.jpg";